import Image from 'next/image';

export function RankBadge({ rank, badges }: { rank: number; badges?: Record<number, string> }) {
  const badge = badges?.[rank];

  if (badge) {
    return <Image src={badge} alt={`Rank ${rank}`} width={36} height={36} className="w-9 h-9" />;
  }

  return (
    <div className="w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center">
      <span className="text-stone-600 text-sm font-medium">{rank}</span>
    </div>
  );
}
